import Vue from 'vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faHome, faMinusCircle, faSpinner, faBars, faStar } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faHome, faSpinner, faMinusCircle, faBars, faStar)

Vue.component('fa-icon', FontAwesomeIcon)